/** 财务收款相关类型 */

/** 付款状态 */
export enum PaymentStatus {
  UNPAID = 'UNPAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PAID = 'PAID',
  OVERDUE = 'OVERDUE',
  DISPUTED = 'DISPUTED',
}

/** 付款方式 */
export enum PaymentMethod {
  T_T = 'T_T',
  L_C = 'L_C',
  BLU_CREDIT = 'BLU_CREDIT',
  WIRE_TRANSFER = 'WIRE_TRANSFER',
}

/** 水单状态 */
export enum WaterSlipStatus {
  VERIFIED = 'VERIFIED',
  PENDING = 'PENDING',
  UNSUBMITTED = 'UNSUBMITTED',
}

/** 应收显示状态（UI 专用，5 种 V1 状态） */
export enum ReceivableDisplayStatus {
  OVERDUE_7D = 'OVERDUE_7D',
  OVERDUE_3D = 'OVERDUE_3D',
  DUE_SOON = 'DUE_SOON',
  NORMAL = 'NORMAL',
  COMPLETED = 'COMPLETED',
}

/** 付款节点 */
export enum PaymentNode {
  T_T_DEPOSIT = 'T_T_DEPOSIT',
  T_T_BALANCE = 'T_T_BALANCE',
  FULLY_PAID = 'FULLY_PAID',
  L_C = 'L_C',
  BLU_CREDIT = 'BLU_CREDIT',
}

/** 付款记录 */
export interface PaymentRecord {
  id: string;
  amount: number;
  method: PaymentMethod;
  transactionNo: string;
  paidAt: string;
  status: string;
}

/** 财务收款 */
export interface FinanceReceivable {
  id: string;
  orderId: string;
  orderNo: string;
  buyerName: string;
  amount: number;
  paidAmount: number;
  currency: string;
  dueDate: string;
  status: PaymentStatus;
  paymentRecords: PaymentRecord[];
  bluCreditApplied: boolean;
  bluCreditAmount: number;
  /** 水单核销状态 */
  waterSlipStatus: WaterSlipStatus;
  /** UI 显示状态（按逾期天数计算） */
  displayStatus: ReceivableDisplayStatus;
  /** 付款节点类型 */
  paymentNode: PaymentNode;
  /** 付款节点中文标签，如 "T/T 30%定金" */
  paymentNodeLabel: string;
  /** 逾期天数（0 = 未逾期） */
  overdueDays: number;
}

/** 水单 */
export interface WaterSlip {
  id: string;
  orderId: string;
  orderNo: string;
  /** 水单号，如 "WS-2025-07001" */
  slipNo: string;
  amount: number;
  currency: string;
  /** ISO 8601 */
  submitDate: string;
  status: WaterSlipStatus;
  /** 核销时间（已核销时存在） */
  verifiedAt?: string;
}

/** 收款计划 */
export interface PaymentPlan {
  id: string;
  orderId: string;
  orderNo: string;
  buyerName: string;
  plannedAmount: number;
  currency: string;
  /** ISO 8601 */
  plannedDate: string;
  paymentNode: PaymentNode;
  /** 'pending' | 'completed' | 'overdue' */
  status: string;
}

/** 汇率 */
export interface ExchangeRate {
  id: string;
  /** 如 "USD" */
  fromCurrency: string;
  /** 如 "CNY" */
  toCurrency: string;
  /** 如 7.2368 */
  rate: number;
  /** 如 0.12（表示 +0.12%） */
  changePercent: number;
  /** ISO 8601 */
  updatedAt: string;
}

/** 汇兑记录 */
export interface ExchangeRecord {
  id: string;
  orderNo: string;
  buyer: string;
  date: string;
  fromCurrency: string;
  toCurrency: string;
  rate: number;
  fromAmount: number;
  toAmount: number;
  remark?: string;
}

/** 收款结构项 */
export interface PaymentStructureItem {
  method: PaymentNode;
  /** 如 "T/T 定金" */
  label: string;
  /** 如 40 */
  percentage: number;
  /** 如 3280000 */
  amount: number;
}

/** 财务统计面板数据 */
export interface FinanceStats {
  /** 应收总额 */
  totalReceivable: number;
  /** 已收款 */
  totalPaid: number;
  /** 回款率(%)，如 74.4 */
  collectionRate: number;
  /** 待收款 */
  pendingAmount: number;
  /** 15日内到期金额 */
  pendingDueSoon: number;
  /** 如 "15日内到期" */
  pendingDueSoonLabel: string;
  /** 逾期应收 */
  overdueAmount: number;
  /** 逾期笔数 */
  overdueCount: number;
  /** 最长逾期天数 */
  maxOverdueDays: number;
  /** 如 "3笔·最长7天" */
  overdueLabel: string;
  /** 统计币种 */
  currency: string;
}
